import { ReactNode, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'

export const SlidingTransition = ({
  children,
  inProp,
  onExit,
}: {
  children: ReactNode
  inProp: boolean
  onExit: () => void
}) => {
  const nodeRef = useRef(null)
  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={inProp}
      appear
      timeout={500}
      classNames="sliding-transition"
      onExited={onExit}
    >
      <div ref={nodeRef}>{children}</div>
    </CSSTransition>
  )
}
